<template lang="pug">
.pdp-display(v-if="product")
  .pdp-display__wrapper.wrapper
    .pdp-display__gallery
      product-gallery(
        v-bind="{ product, variant, enableBuyInStore, enableBuyOnline }"
      )
    .pdp-display__form
      product-form(
        v-bind="{ product, nutritionalDisclaimer, shippingText, nutritionFactsVisible }"
        @variantChange="onVariantChange"
      )
      product-buy-in-store(
        if="enableBuyInStore"
        v-bind="{ product, variant, zipModalHeading, zipModalBody }"
      )
</template>

<script>
  import ProductBuyInStore from 'scripts/components/product/ProductBuyInStore.vue';
  import ProductForm from 'scripts/components/product/ProductForm.vue';
  import ProductGallery from 'scripts/components/product/ProductGallery.vue';

  export default {
    name: 'ProductDisplay',
    components: {
      ProductGallery,
      ProductForm,
      ProductBuyInStore,
    },
    props: {
      product: Object,
      shippingText: String,
      nutritionalDisclaimer: String,
      nutritionFactsVisible: Boolean,
      zipModalHeading: String,
      zipModalBody: String,
    },
    data() {
      return {
        variant: this.product.variants[0],
        enableBuyInStore: this.product.variants[0].enable_buy_in_store,
        enableBuyOnline: this.product.variants[0].enable_buy_online,
      }
    },
    methods: {
      onVariantChange(variant) {
        this.variant = variant;
        this.enableBuyInStore = variant.enable_buy_in_store;
        this.enableBuyOnline = variant.enable_buy_online;
        this.triggerViewItemEvent(variant);

        // Push history state
        const newPath = window.location.pathname + '?id=' + variant.id;
        history.pushState({}, null, newPath);
      },
      triggerViewItemEvent(variant) {
        /*window.getCustomerGuid((customer_guid, _customer_status, dev) => {
          if (dev)
            return;
          let viewItemPayload = {
            'event': 'bva_view_item',
            'user_id': customer_guid,
            'event_id': new Date().getTime() + '.' + Math.random().toString(36).substring(5),
            'ecommerce': {
              'currencyCode': window.BVA.shop.currencyCode,
              'detail': {
                'actionField': {'list': 'product'},
                'products': [{
                  'id': variant.barcode,
                  'sku': variant.sku,
                  'handle': this.product.handle,
                  'productId': this.product.id,
                  'variantId': variant.id,
                  'name' : this.product.title.replace("'", ""),
                  'price': (variant.price / 100),
                  'brand' : this.product.vendor.replace("'", ""),
                  'variant': variant.title.replace("'", ""),
                  'category': this.product.type.replace("'",""),
                }]
              },
              'items': [
                {
                  item_id: variant.barcode,
                  gmi_product_id: variant.gmi_product_id,
                  shopify_product_id: this.product.id,
                  shopify_variant_id: variant.id,
                  shopify_sku: (variant.sku || '').replace("'", ""),
                  shopify_handle: this.product.handle,
                  shopify_compare_price: (variant.compare_at_price || variant.price) / 100,
                  item_name : this.product.title.replace("'", ""),
                  affiliation: window.BVA.shop.name,
                  currency: window.BVA.shop.currencyCode,
                  item_brand : this.product.vendor.replace("'", ""),
                  item_category: variant.gmi_product_id,
                  item_list_id: 'product',
                  item_list_name: 'product',
                  item_variant: variant.title.replace("'",""),
                  price: (variant.price / 100),
                }
              ]
            }
          }

          Object.keys(this.product.options_with_values).forEach((key) => {
            viewItemPayload.ecommerce.items[0][key] = this.product.options_with_values[key]
          });

          window.dataLayer = window.dataLayer || [];
          dataLayer.push({ ecommerce: null });
          dataLayer.push(viewItemPayload);
          console.log('event: view-event', viewItemPayload);
        });*/
      }
    },
    mounted() {
      if (this.product.has_only_default_variant) {
        this.triggerViewItemEvent(this.variant);
      }
    }
  }
</script>

<style scoped lang="scss">
.pdp-display {
  @include tablet-up() {
    padding: rem(24px) 0 rem(40px) 0;
  }
}
.pdp-display__wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  @include tablet-up() {
    flex-wrap: nowrap;
    flex-direction: row;
  }
  @include hd-down() {
    padding: 0 $spacing-unit;
  }
  @include mobile-only() {
    padding: 0;
  }
}

.pdp-display__gallery {
  width: 100%;
  padding-top: 24px;

  @include tablet-up() {
    max-width: 53%;
  }
}

.pdp-display__form {
  width: 100%;
}
</style>
